import { authHeaders, baseUrl, handleResponse } from "./apiUtils";

// Only the current portal scope may expire a session. A late response from
// another account must not remove the token installed by a context switch.
function handlePortalResponse(response) {
  if (response.status === 401) {
    const error = new Error("Unauthorized");
    error.code = 401;
    throw error;
  }
  return handleResponse(response);
}

async function getClientPortal() {
  const response = await fetch(`${baseUrl}self-service/client-portal`, {
    headers: authHeaders(),
  });
  return handlePortalResponse(response);
}

async function cancelLessonParticipation({ lessonId, studentId }) {
  const response = await fetch(
    `${baseUrl}self-service/client-portal/lessons/${encodeURIComponent(lessonId)}/cancel`,
    {
      method: "POST",
      headers: authHeaders({ "content-type": "application/json" }),
      body: JSON.stringify({ studentId }),
    },
  );
  return handlePortalResponse(response);
}

async function undoLessonCancellation({ lessonId, studentId }) {
  const response = await fetch(
    `${baseUrl}self-service/client-portal/lessons/${encodeURIComponent(lessonId)}/undo-cancellation`,
    {
      method: "POST",
      headers: authHeaders({ "content-type": "application/json" }),
      body: JSON.stringify({ studentId }),
    },
  );
  return handlePortalResponse(response);
}

export default {
  getClientPortal,
  cancelLessonParticipation,
  undoLessonCancellation,
};
